import { render, staticRenderFns } from "./ContainerImportacaoAzureAD.vue?vue&type=template&id=3af54cff&"
import script from "./ContainerImportacaoAzureAD.vue?vue&type=script&lang=js&"
export * from "./ContainerImportacaoAzureAD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports